module.exports = "pegasus/assets/theme4/large/1.jpg";